<template>
  <div class="contact-us full-screen">
    <div class="wrapper wrapper-full-page section content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 col-md-6 p-0">
            <div id="register" class="background d-none d-md-block">
              <div class="register-box">
                  <img src="logo_ecoverse.png" height="150" width="160"/>
                  <h2 class="title">The Ecoverse by Net Zero Analytics</h2>
                  <h6>Already have an account?</h6>
                  <button class="btn-general" type="button" @click="goToLogin()">Sign in</button>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6" style="display: flex; align-items: center; justify-content: center;">
            <div class="form">
              <img src="logo_ecoverse.png" height="150" width="160"/>
              <h2 class="title black-title">Create account</h2>
              <h6 class="black-title">Fill your information</h6>
              <div class="form-group">
                <input id="firstname_input" type="text" placeholder="First Name" v-model.trim="firstName" required>
              </div>
              <div class="form-group mt-4">
                <input id="lastname_input" type="text" v-model.trim="lastName" placeholder="Last Name" required>
              </div>
              <div class="form-group mt-4">
                <input id="email_input" type="email" placeholder="Email" v-model.trim="email" required>
                <div><span class="text-muted">(we will send you a verification link)</span></div>
              </div>
              <div class="form-group mt-3">
                <input id="phone_input" type="text" placeholder="Contact Phone" v-model.trim="phone" required>
              </div>
              <div class="form-group mt-4">
                <input id="position_input" type="text" placeholder="Job Title" v-model.trim="position" required>
              </div>
              <div class="form-group mt-4">
                <input id="password_input" type="password" placeholder="Password" v-model.trim="password" required>
              </div>
              <div class="form-group mt-4">
                <input id="password2_input" type="password" placeholder="Confirm Password" v-model.trim="password2" required>
              </div>
              <div class="form-group mt-4">
                <div>
                  <label class="control-label">
                    <input type="checkbox" style="width:auto;" v-model="privacyConsent">
                    I have read and agree with the <a target="_blank" href="https://cdn.theecoverse.net/documents/ECOVERSE_PRIVACY_POLICY_ENG.pdf">privacy policy</a> of The Ecoverse
                  </label>
                </div>
                <div>
                  <label class="control-label">
                    <input type="checkbox" style="width:auto;" v-model="termsConsent">
                    I have read and agree with the <a target="_blank" href="https://cdn.theecoverse.net/documents/ECOVERSE_TERMS_ENG.pdf">terms and conditions</a> of The Ecoverse
                  </label>
                </div>
              </div>

              <div class="text-center">
                <button class="btn-general-black" @click="register" :disabled="loading">Register<span v-if="loading">...</span></button>
                <div v-if="errorMsg !== ''" class="text-danger mt-1">{{ errorMsg }}</div>
              </div>
              <div class="text-center mt-2">
                <div class=""><router-link class="password-reset" :to="{path:'/login'}">Already have an Account</router-link></div>
              </div>    
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Api from "../api";
export default {
  name: "register",
  data() {
    return {
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      position: "",
      password: "",
      password2: "",
      errorMsg: "",
      loading: false,
      termsConsent: false,
      privacyConsent: false
    };
  },
  methods: {
    register () {
      this.errorMsg = "";
      if (this.firstName === "" || this.lastName === "" || this.email === "" || this.phone === "" || this.position === "" || this.password === "") {
        this.errorMsg = "Please fill in all fields";
        return false;
      }
      if (this.password2 !== this.password) {
        this.errorMsg = "Please confirm your password correctly";
        return false;
      }
      if (!this.privacyConsent) {
        this.errorMsg = "You need to declare that you have read and agree with the privacy policy of The Ecoverse";
        return false;
      }
      if (!this.termsConsent) {
        this.errorMsg = "You need to declare that you have read and agree with the terms and conditions of The Ecoverse";
        return false;
      }

      this.loading = true;
      Api.send("POST", "/user/register", {firstName: this.firstName, lastName: this.lastName, email: this.email, phone :this.phone, position :this.position, password: this.password}, false)
      .then((response) => {
        this.errorMsg = "";
        this.$router.push({name: 'register_success'})
      })
      .catch((err) => {
        this.errorMsg = err.msg;
      })
      .finally(() => {
        this.loading = false;
      });
    },

    goToLogin() {
      this.$router.push({name: 'login'})
    }
  },
};
</script>
<style scoped>
h1,h2,h3,h4,h5,h6,p, button{
      color:white;
      font-family: "Poppins";
}
h6 {
     font-size: 14px; 
     font-weight: 200;
}
.background {
    height: 100vh;
    background-size: cover;
}
.btn-general {
    border: 2px solid white;
    padding: 5px 65px 5px 65px;
    background: none;
}
.btn-general:hover {
    border: 2px solid #f0f0f0;
    color: #f0f0f0;
    cursor: pointer;
}
.btn-general-black{
    border: 2px solid black;
    padding: 5px 105px 5px 105px;
    background: none;
    color: black;
    margin-top: 30px;
}
.btn-general-black:hover {
    border: 2px solid #959393;
    color: #959393;
    cursor: pointer;
}
.black {color:black;}
.same-line{white-space: nowrap;}
h6 {            
    font-size: 14px; 
    font-weight: 200;
}
.background {
    height: 100vh;
    background-size: cover;
}
#register {
  background-image: url("/register.jpg");
  background-position: center;
}
.register-box {
    text-align: center;
    position: absolute;
    top: 200px;
    width: 100%;
    background: rgba(18, 18, 18, 0.4);
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.3);
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);
    padding: 20px;
    border-radius: 0px 150px 0px 0px;
}
.register-box img {
    margin-bottom: 20px;
}
.register-box h6 {
  margin-bottom: 20px;
}
.title {
  font-size: 21px;   
}
.form {
    width: 100%;
    margin: 0;
    text-align: center;
}
.form input {
    width: 80%;
    max-width: 400px;
    border-top: none;
    border-right: none;
    border-left: none;
    border-bottom: 0.2px solid #959393;
    color: #959393;
    font-weight: 100;
    font-size: 18px;
}
.black-title {
    color: black;
}
.form h6 {margin-bottom: 50px;}
.password-reset {
    color: #959393;
    font-size: 16px;
    font-weight: 100;
}
</style>
